import script from "./PatientHC.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientHC.vue?vue&type=script&setup=true&lang=js"

import "./PatientHC.vue?vue&type=style&index=0&id=79c56e81&setup=true&lang=css"

const __exports__ = script;

export default __exports__